import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addData, dtos, getData, stod } from "./utils";
import pt from "date-fns/locale/pt-BR";
import { useState } from "react";
import { makeid } from "utils/random";
registerLocale("pt", pt);

interface IFormImputDateProps extends IFormInputDefault{
  onlyMonth?: boolean;
  range?: {
    min?: string;
    max?: string;
  };
  notKey?: boolean;
}

export default function FormImputDate({
  title,
  name,
  state,
  onChange,
  onlyMonth,
  range,
  notKey,
  ...props
}:IFormImputDateProps){
  const [ ID ] = useState(`${makeid(10)}`)
  let {cleanable, onClear, value, ...props_aux} = props;
  // props_aux["dateFormat"] = "dd/MM/yyyy";
  if(value){
    props_aux["selected"] = stod(value);
  }
  if(state && name){
    props_aux["name"] = name+"-"+ID;
    props_aux["selected"] = stod(state.model?getData(state.model,name):"");
  }

  if(onlyMonth){
    props_aux["showMonthYearPicker"] = true;
    props_aux["dateFormat"] = "MMM/yyyy";
  }

  if(range){
    props_aux["minDate"] = range.min?stod(range.min):undefined;
    props_aux["maxDate"] = range.max?stod(range.max):undefined;
  }

  return (
    <BodyInputFormat props={{...props,title}}>
      {/* <Form.Control size="sm"
        onChange={(event)=>{
          if(state && name){
            let value = event.target.value;

            state.setModel((old:any)=>{
              let m = {...old};
              m[name] = value;
              return m;
            });
          }if(onChange)onChange(event)
        }} 
        {...props_aux}
      /> */}
      <DatePicker 
        onChange={(date) => {
          if(state && name && date){
            state.setModel((old:any)=>{
              return addData(old,name,dtos(date));
            });
          }
          if(onChange)onChange(date?dtos(date):null)
        }} 
        className="form-control form-control-sm"
        dateFormat="dd/MM/yyyy"
        locale="pt"
        popperPlacement="top-end"
        onKeyDown={(e) => {
          if(notKey)e.preventDefault();
        }}
        {...props_aux}
      />
    </BodyInputFormat>
  );
}